import * as types from '../../mutationTypes';

export default {
  async assignList({ commit }, list) {
    commit(types.ASSIGN_LIST, list);
  }
};
